import { useEffect, useState } from 'react';
import List from '../components/list/List';
import { s } from './Mypage.styles';
import {
  CourtList,
  FilterType,
  ItemStatusList,
  ProgressStatusList,
  PTypeItemStatusList,
  PTypeProgressStatusList,
  RatingData,
  Region,
  RegionProps,
  SidoList,
} from '../search/FilterData';
import Select from 'react-select';
import RegionService from '../../service/Region';
import InterestSerivce from '../../service/Interest';
import AddInterestItemModal from '../components/modal/AddInterestItem';

type SortOption = { value: string; label: string };
interface GroupOption {
  label: string;
  value: string;
}

const MyPageFilter = () => {
  const [filters, setFilters] = useState<FilterType>({
    type: 'a',
    regionOrCourt: 'r',
    region: [] as Region[],
    court: '',
    itemStatus: [],
    multiItemStatus: [],
    appraisalPrice: { min: '', max: '' },
    minPrice: { min: '', max: '' },
    saleDate: { start: '', end: '' },
    approvalDate: { start: '', end: '' },
    buildingArea: { min: '', max: '' },
    landArea: { min: '', max: '' },
    bidno: '',
    progressStatus: '진행',
    useArea: [],
    multiUseArea: [],
    specialConditionViewOption: 'o',
    specialItemCondition: [],
    multiSpecialItemCondition: [],
    group: '',
    level: '',
    holdingCompany: [],
    multiHoldingCompany: [],
  });
  const [sido, setSido] = useState('');
  const [sigungu, setSigungu] = useState('');
  const [emd, setEmd] = useState('');
  const [sigunguList, setSigunguList] = useState<RegionProps[] | undefined>([]);
  const [emdList, setEmdList] = useState<RegionProps[] | undefined>([]);
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState([]);
  const [sort, setSort] = useState<SortOption>({
    value: 'DA',
    label: '매각기일 빠른순',
  });
  const [groupList, setGroupList] = useState<GroupOption[]>([]);
  const [showLikeModal, setShowLikeModal] = useState<boolean>(false);
  const [mode, setMode] = useState<string>('add');
  const [selectedIdx, setSelectedIdx] = useState<number>(0);
  const [selectedItem, setSelectedItem] = useState({
    iidx: 0,
    group: '',
    group_idx: 0,
    level: 0,
    memo: '',
  });
  const [activeItem, setActiveItem] = useState<number | null>(null);

  const groupOptions = [{ label: '전체', value: '전체' }, ...(groupList || [])];

  const [loading, setLoading] = useState(false);

  const getGroupList = async () => {
    setLoading(true);
    try {
      const res = await InterestSerivce.groupList();
      setGroupList(
        res.data.map((item: any) => ({
          label: item.group,
          value: String(item.group_idx),
        })),
      );
      setLoading(false);
    } catch (error) {
      console.error('groupList 함수에서 에러 발생:', error);
    }
  };

  useEffect(() => {
    getGroupList();
  }, []);

  const customStyles = {
    control: (provided: any) => ({
      ...provided,
      display: 'flex',
      flexDirection: 'row',
      borderRadius: '8px',
      border: 'none',
      height: '40px',
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      padding: 0,
      backgroundColor: '#F7F8FC',
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      order: 1,
    }),
    indicatorSeparator: (provided: any) => ({
      ...provided,
      display: 'none',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      fontFamily: 'Spoqa Han Sans Neo',
      fontSize: '12px',
      fontWeight: 500,
      backgroundColor: state.isSelected ? '#e6e6e6' : provided.backgroundColor,
      color: state.isSelected ? '#000' : '#333',
    }),
    placeholder: (provided: any) => ({
      ...provided,
      whiteSpace: 'nowrap',
    }),
  };
  const getRegion = async (code: string) => {
    try {
      const res = await RegionService.list(code);
      return res.data as RegionProps[];
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (sido !== '') {
      getRegion(sido).then((res) => setSigunguList(res));
    }
  }, [sido]);

  useEffect(() => {
    if (sigungu !== '') {
      getRegion(sigungu).then((res) => setEmdList(res));
    }
  }, [sigungu]);

  const sidoOptions = SidoList.map((sido) => ({
    value: sido.code,
    label: sido.region,
  }));
  const sigunguOptions = (sigunguList ?? []).map((sigungu) => ({
    value: sigungu.code,
    label: sigungu.region,
  }));
  const emdOptions = (emdList ?? [])
    .filter((emd) => emd.region !== '전체')
    .map((emd) => ({
      value: emd.code,
      label: emd.region,
    }));

  const getList = async (
    offset: number,
    sort: {
      value: string;
      label: string;
    },
    currentFilters: FilterType,
  ) => {
    setLoading(true);
    try {
      const res = await InterestSerivce.list(
        'Y',
        currentFilters.type,
        currentFilters.regionOrCourt,
        currentFilters.court,
        currentFilters.region
          .map((item) => `${item.sido} ${item.sigungu} ${item.emd}`)
          .join(','),
        '',
        '',
        currentFilters.progressStatus,
        currentFilters.itemStatus.join(',') === ''
          ? currentFilters.multiItemStatus.join(',')
          : currentFilters.itemStatus.join(','),
        currentFilters.group === '' ? -1 : Number(currentFilters.group),
        currentFilters.level === '' ? 0 : Number(currentFilters.level),
        sort.value,
        limit,
        offset,
      );
      setData(res.data.list);
      setTotal(Number(res.data.countInfo.total));
      setLoading(false);
    } catch (error) {
      console.error('getList 함수에서 에러 발생:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(0, sort, filters);
  }, []);

  useEffect(() => {
    getList(offset, sort, filters);
  }, [offset]);

  useEffect(() => {
    if (data.length === 0) return;
    setOffset(0);
    getList(0, sort, filters);
  }, [sort]);

  // useEffect(() => {
  //   if (data.length === 0) return;
  //   setOffset(0);
  //   getList(0, sort, filters);
  // }, [currentTab]);

  const renderRegionOrCourt = () => {
    if (filters.regionOrCourt === 'r') {
      return (
        <s.FilterRow>
          <s.FilterRowContent>
            <div style={{ flex: 1 }}>
              <Select
                options={sidoOptions}
                value={
                  sidoOptions.find(
                    (option) => option.label === filters.region[0]?.sido,
                  ) || null
                }
                styles={customStyles}
                placeholder="시/도"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSido(selectedOption.value);
                    setSigungu('');
                    setEmd('');
                    setFilters({
                      ...filters,
                      region: [
                        { sido: selectedOption.label, sigungu: '', emd: '' },
                      ],
                    });
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Select
                options={sigunguOptions}
                value={
                  sigunguOptions.find(
                    (option) => option.label === filters.region[0]?.sigungu,
                  ) || null
                }
                styles={customStyles}
                placeholder="시/군/구"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setSigungu(selectedOption.value);
                    setEmd('');
                    setFilters({
                      ...filters,
                      region: [
                        {
                          sido: filters.region[0]?.sido,
                          sigungu: selectedOption.label,
                          emd: '',
                        },
                      ],
                    });
                  }
                }}
              />
            </div>
            <div style={{ flex: 1 }}>
              <Select
                options={emdOptions}
                value={
                  emdOptions.find(
                    (option) => option.label === filters.region[0]?.emd,
                  ) || null
                }
                styles={{
                  ...customStyles,
                  control: (provided: any) => ({
                    ...customStyles.control(provided),
                  }),
                }}
                placeholder="읍/면/동"
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setEmd(selectedOption.value);
                    setFilters({
                      ...filters,
                      region: [
                        {
                          sido: filters.region[0].sido,
                          sigungu: filters.region[0].sigungu,
                          emd: selectedOption.label,
                        },
                      ],
                    });
                  }
                }}
              />
            </div>
          </s.FilterRowContent>
        </s.FilterRow>
      );
    } else {
      return (
        <s.FilterRow>
          <Select
            options={CourtList}
            styles={{
              ...customStyles,
              control: (provided: any) => ({
                ...customStyles.control(provided),
              }),
            }}
            value={
              filters.court === ''
                ? null
                : {
                    label: filters.court,
                    value: filters.court,
                  }
            }
            placeholder="법원 선택"
            onChange={(selectedOption) => {
              if (selectedOption) {
                setFilters({ ...filters, court: selectedOption.value });
              }
            }}
          />
        </s.FilterRow>
      );
    }
  };

  const handleReSet = () => {
    setFilters({
      type: 'a',
      regionOrCourt: 'r',
      region: [],
      court: '',
      itemStatus: [],
      multiItemStatus: [],
      appraisalPrice: { min: '', max: '' },
      minPrice: { min: '', max: '' },
      saleDate: { start: '', end: '' },
      approvalDate: { start: '', end: '' },
      buildingArea: { min: '', max: '' },
      landArea: { min: '', max: '' },
      bidno: '',
      progressStatus: '진행',
      useArea: [],
      multiUseArea: [],
      specialConditionViewOption: 'o',
      specialItemCondition: [],
      multiSpecialItemCondition: [],
      group: '',
      level: '',
      holdingCompany: [],
      multiHoldingCompany: [],
    });
    setSido('');
    setSigungu('');
    setEmd('');
  };
  return (
    <s.Container>
      <s.FilterBox>
        <s.FilterInner>
          <s.FilterOptionBox>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <s.FilterRow>
                <s.FilterLabel>물건분류</s.FilterLabel>
                <s.TabButtonBox>
                  <s.TabButton
                    isActive={filters.type === 'a'}
                    onClick={() => {
                      setFilters({ ...filters, type: 'a' });
                    }}
                  >
                    경매
                  </s.TabButton>
                  <s.TabButton
                    isActive={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, type: 'p', regionOrCourt: 'r' });
                    }}
                  >
                    공매
                  </s.TabButton>
                </s.TabButtonBox>
              </s.FilterRow>
              <s.FilterRow>
                <s.FilterLabel>지역/법원</s.FilterLabel>
                <s.TabButtonBox>
                  <s.TabButton
                    isActive={filters.regionOrCourt === 'r'}
                    disabled={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, regionOrCourt: 'r' });
                    }}
                    style={{
                      border:
                        filters.type === 'p'
                          ? '1px solid rgba(55, 56, 60, 0.16)'
                          : '',
                      color:
                        filters.type === 'p' ? 'rgba(55, 56, 60, 0.16)' : '',
                    }}
                  >
                    지역
                  </s.TabButton>
                  <s.TabButton
                    isActive={filters.regionOrCourt === 'c'}
                    disabled={filters.type === 'p'}
                    onClick={() => {
                      setFilters({ ...filters, regionOrCourt: 'c' });
                    }}
                    style={{
                      color:
                        filters.type === 'p' ? 'rgba(55, 56, 60, 0.16)' : '',
                    }}
                  >
                    법원
                  </s.TabButton>
                </s.TabButtonBox>
              </s.FilterRow>
            </div>
            {renderRegionOrCourt()}
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <div style={{ flex: 1 }}>
                <Select
                  options={
                    filters.type === 'p' ? PTypeItemStatusList : ItemStatusList
                  }
                  styles={{
                    ...customStyles,
                    control: (provided: any) => ({
                      ...customStyles.control(provided),
                    }),
                  }}
                  placeholder="물건종류"
                  value={
                    filters.itemStatus.length > 0
                      ? {
                          label: filters.itemStatus[0],
                          value: filters.itemStatus[0],
                        }
                      : null
                  }
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setFilters({
                        ...filters,
                        multiItemStatus: [],
                        itemStatus: [selectedOption.label],
                      });
                    }
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Select
                  options={
                    filters.type === 'p'
                      ? PTypeProgressStatusList
                      : ProgressStatusList
                  }
                  styles={{
                    ...customStyles,
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                  }}
                  menuPortalTarget={document.body}
                  placeholder="진행단계"
                  value={
                    filters.progressStatus === ''
                      ? null
                      : {
                          label: filters.progressStatus,
                          value: filters.progressStatus,
                        }
                  }
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setFilters({
                        ...filters,
                        progressStatus: selectedOption.label,
                      });
                    }
                  }}
                />
              </div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <div style={{ flex: 1 }}>
                <Select
                  options={groupOptions}
                  styles={{
                    ...customStyles,
                    control: (provided: any) => ({
                      ...customStyles.control(provided),
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={
                    filters.group === ''
                      ? null
                      : (groupList?.find(
                          (item) => item.value === filters.group,
                        ) ?? null)
                  }
                  placeholder="그룹"
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setFilters({ ...filters, group: selectedOption.value });
                    }
                  }}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Select
                  options={RatingData}
                  styles={{
                    ...customStyles,
                    control: (provided: any) => ({
                      ...customStyles.control(provided),
                    }),
                  }}
                  menuPortalTarget={document.body}
                  value={
                    filters.level === ''
                      ? null
                      : (RatingData?.find(
                          (item) => item.value === filters.level,
                        ) ?? null)
                  }
                  placeholder="관심도"
                  onChange={(selectedOption) => {
                    if (selectedOption) {
                      setFilters({ ...filters, level: selectedOption.value });
                    }
                  }}
                />
              </div>
            </div>
          </s.FilterOptionBox>
          <s.ButtonBox>
            <s.ResetButton onClick={handleReSet}>
              <img src="/assets/images/icon/reset.svg" alt="" />
              <span>초기화</span>
            </s.ResetButton>
            <s.ApplyButton
              onClick={() => {
                getList(offset, sort, filters);
              }}
            >
              검색
            </s.ApplyButton>
          </s.ButtonBox>
        </s.FilterInner>
      </s.FilterBox>
      <List
        data={data}
        totalCount={total}
        sort={sort}
        setSort={setSort}
        offset={offset}
        setOffset={setOffset}
        filters={filters}
        limit={limit}
        loading={loading}
        page="interest"
        setSelectedIdx={setSelectedIdx}
        setShowLikeModal={setShowLikeModal}
        setMode={setMode}
        setSelectedItem={setSelectedItem}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
        getList={getList}
      />
      {showLikeModal && (
        <AddInterestItemModal
          setShowLikeModal={setShowLikeModal}
          selectedIdx={selectedIdx}
          mode={mode}
          selectedItem={selectedItem}
          getList={getList}
          offset={offset}
          sort={sort}
          filters={filters}
          setActiveItem={setActiveItem}
        />
      )}
    </s.Container>
  );
};

export default MyPageFilter;
